var audio = require('../audio');

var timestamps = [
	{ timestamp: '00.14.366', actions: ['color']					},
	{ timestamp: '00.42.383', actions: ['color']                    },
	{ timestamp: '00.56.490', actions: ['color', 'sine_on']        },
	// start color change section
	{ timestamp: '01.24.723', actions: ['color']                    },
	{ timestamp: '01.31.785', actions: ['color']                    },
	{ timestamp: '01.38.841', actions: ['color']                    },
	{ timestamp: '01.45.899', actions: ['color']                    },
	{ timestamp: '01.52.959', actions: ['color']         },
	{ timestamp: '02.00.016', actions: ['color']                    },
	{ timestamp: '02.07.076', actions: ['color']                    },
	{ timestamp: '02.14.134', actions: ['color']                    },
	// quiet part
	{ timestamp: '02.21.200', actions: ['color']                    },
	{ timestamp: '02.49.428', actions: ['sine_off', 'displacement', 'color'] },
	{ timestamp: '03.45.900', actions: ['color', 'sine_on']             		}
];

var song_markers = timestamps.map(function(t) {
  var parts = t.timestamp.split('.');
  var time = +parts[0] * 60;
  time += +parts[1];
  time += (+parts[2] * 1/1000);
  t.time = time;
  return t;
});

// ======================================================
// STRUCTURE CHANGES
// ======================================================

var song = new Bacon.Bus();

audio.structure_stream.onValue( function(position) {
	if (position === 0) return;
	song.push(find_action(song_markers, position));
});

var changes = song.skipDuplicates();

function find_action(arr, val) {
	for(var i = arr.length - 1; i >= 0; i--) {
		if(val >= arr[i].time) {
			return arr[i];
		}
	}
	return null;
}

module.exports = changes;